import { rootStore } from '@/mobx-models/Root';

import {
  BorerOperatorChange,
  BorerOperatorChangeState,
} from '../BorerOperatorChangeFeed/queryBuilder';
import RxdbCollectionName from '../rxdbCollectionName';
import RxdbManager from '../RxdbManager';
import {
  generateBaseEntityWithCreatedOn,
  getUnixMillisecondTimestamp,
} from '../rxdbUtilityFunctions';

// Save Sub routine
export const saveBorerOperatorChange = async (
  borerStateId: string,
  states: BorerOperatorChangeState[],
  existingTempStateId?: string,
) => {
  const borerEquipmentId = rootStore.equipment.selectedBorerId;
  const db = RxdbManager.instance?.db;
  const borerOperatorChangeCollection =
    db?.collections[RxdbCollectionName.BORER_OPERATOR_CHANGE_FEED];
  if (!borerOperatorChangeCollection || !borerEquipmentId) {
    throw new Error('🚀 ~ Missing collection or borerEquipmentId');
  }
  if (!borerStateId) {
    throw new Error('🚀 ~borerOperatorChangeQueries.ts:118 Missing borerStateId');
  }
  try {
    if (existingTempStateId) {
      // Update the existing temp state
      const existingDoc = await borerOperatorChangeCollection
        .findOne({
          selector: {
            id: existingTempStateId,
          },
        })
        .exec();
      if (existingDoc) {
        await existingDoc.incrementalPatch({
          showInSchedulerView: false,
          updatedAt: getUnixMillisecondTimestamp(),
        });
      } else {
        console.error('Existing temp state provided, but doc not found');
      }
    }

    // Always make new doc with new ID
    // Otherwise, updates that are set with same ID will be ignored by BE
    const changeDoc: BorerOperatorChange = {
      ...generateBaseEntityWithCreatedOn(),
      borerStateId,
      states,
      borerEquipmentId,
      showInSchedulerView: true,
      failedSync: false,
      isGeneratedState: false,
    };

    return await borerOperatorChangeCollection.upsert(changeDoc);
  } catch (err) {
    console.log('🚀 ~ file: useBorerOperatorChange.tsx:140 ~ err', err);
    throw new Error('🚀 ~ Unable to save borer operator change');
  }
};

// Save Sub routine
export const markTempStatesAsHiddenForBorerStateId = async (borerStateId: string) => {
  const db = RxdbManager.instance?.db;
  const borerOperatorChangeCollection =
    db?.collections[RxdbCollectionName.BORER_OPERATOR_CHANGE_FEED];

  if (!borerStateId) {
    throw new Error('🚀 ~ Missing borerStateId within markTempStatesAsHiddenForBorerStateId');
  }
  try {
    const existingDocs = await borerOperatorChangeCollection
      ?.find({
        selector: {
          borerStateId,
        },
      })
      .exec();
    if (existingDocs) {
      await Promise.all(
        existingDocs.map(async doc => doc.modify(old => ({ ...old, showInSchedulerView: false }))),
      );
    }
  } catch (err) {
    console.log(
      '🚀 ~ file: borerOperatorChangeQueries.ts:183 ~ markTempStatesAsHiddenForBorerStateId ~ err:',
      err,
    );
  }
};
